export const SET_PARAMETERS = "SET_PARAMETERS";
export const SET_SPECIFIC_PARAMETER = "SET_SPECIFIC_PARAMETER";
export const DELETE_SPECIFIC_PARAMETER = "DELETE_SPECIFIC_PARAMETER;";
